import { bl_cms_website_commission_scheme_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class WebsiteCommissionSchemeLinkContainerModel extends BaseContainerModel {
    bl_cms_website_commission_scheme_link: bl_cms_website_commission_scheme_link_RowClass = new bl_cms_website_commission_scheme_link_RowClass();
}